module.exports = __webpack_public_path__ + "percent_blue_bold.676899fb0271d7b31d8f6f326e616fe0.svg";